import { useTranslation } from "react-i18next";

import { HaNResultList } from "../../shared/HaNResultList/HaNResultList";
import { useOpenResult } from "../../shared/useOpenResult";
import { FacilityCell } from "../FacilityCell";
import { useFacilitiesModel } from "../useFacilitiesModel";

// The selected floor's facilities
export const FacilitiesOnFloor = () => {
  const { t } = useTranslation();
  const { isLoading, facilities } = useFacilitiesModel();
  const openResult = useOpenResult();

  if (isLoading) return <HaNResultList.Loading />;
  if (facilities.length === 0) return <HaNResultList.Empty text={t("hereAndNow:NoFacilitiesAvailable")} />;

  return (
    <HaNResultList>
      {facilities.map(facility => (
        <HaNResultList.Item
          key={facility.id}
          nodeId={facility.id}
          onSelect={() => openResult("facility", facility)}>
          <FacilityCell facility={facility} />
        </HaNResultList.Item>
      ))}
    </HaNResultList>
  );
};
